import moment from "moment";
import {api} from "../config";

export default {
  data () {
    return {
      // Log: (this.getLog()) ? this.getLog() : {'learning': [], 'question': []},
      // Log: this.getLog(),
      Log: (this.getLog()) ? this.getLog() : [],
      learning_item: {
        content_id: '',
        started_at: '',
        ended_at: '',
        listening_total_time: 0,
        subtitling_total_time: 0,
        step: '',
        step_sub: '',
        content_order: '',
      },
      play: false,
      enabled_caption: false,
    }
  },
  mounted() {
    this.learning_item.content_id = this.$store.getters.content_id(this.step);
    this.learning_item.started_at = this.getTime();

    this.learning_item.step = this.step;

    if(this.step == 'moviequiz') {
      if(this.stepSub == 'movie') {
        this.learning_item.step_sub = this.stepSub;
        this.learning_item.content_order = this.contentOrder;
      } else if(this.stepSub == 'movie') {
        this.learning_item.step_sub = this.stepSub;
        this.learning_item.content_order = this.contentOrder;
      }
    }

    // Get total time if you have a video
    if ($('video').length > 0) {
      let player = this.$refs.plyr.player
      let start = null
      let end = null
      let caption_start = null
      let caption_end = null

      // Play video
      player.on('play', event => {
        if (this.play) {
          return;
        }
        start = this.getTime();
        this.play = true;

        if (this.enabled_caption) {
          caption_start = this.getTime();
        }
      });

      // Play video
      player.on('timeupdate', event => {
        let current_time = this.getTime();
        this.learning_item.listening_total_time = this.diffTime(start, current_time);

        if (this.enabled_caption) {
          this.learning_item.subtitling_total_time += this.diffTime(caption_start, current_time);
        }
      });

      // End video
      player.on('ended', event => {
        end = this.getTime();
        this.learning_item.listening_total_time = this.diffTime(start, end);
        this.play = false;

        if (this.enabled_caption) {
          caption_end = this.getTime();
          this.learning_item.subtitling_total_time = this.diffTime(caption_start, caption_end);
        }
      });

      // ON caption
      player.on('captionsenabled', event => {
        this.enabled_caption = true;
        
        if (this.play) {
          caption_start = this.getTime();
        }
      });

      // OFF caption
      player.on('captionsdisabled', event => {
        this.enabled_caption = false;

        if (this.play) {
          caption_end = this.getTime();
          this.learning_item.subtitling_total_time = this.diffTime(caption_start, caption_end);
        }
      });
    }
  },



  methods: {
    getTime() {
      return moment().format('YYYY-MM-DD HH:mm:ss');
    },
    diffTime(to_time, from_time) {
      const to = moment(to_time);
      const from = moment(from_time);
      // Return in seconds
      return from.diff(to) / 1000;
    },



    setLog(log) {
      window.sessionStorage.setItem('learning_log', JSON.stringify(log));
    },
    getLog() {
      return JSON.parse(window.sessionStorage.getItem('learning_log'));
    },
    removeLog() {
      window.sessionStorage.removeItem('learning_log');
    },

    learningTempLog() {
      this.learning_item.ended_at = this.getTime();
      // this.Log.learning.push(this.learning_item)
      if(this.learning_item.content_id) {
        this.Log.push(this.learning_item)
        this.setLog(this.Log);
      }
    },


    learningLog() {
      axios.get(api.frontCsrfCookie, { withCredentials: true }).then(() => {
        axios.post(api.updateLearningLog, {
          lesson_id: this.$store.getters.lesson_data.lesson_id,
          log: this.getLog()
        }, { withCredentials: true })
        .then((resp) => {
          this.removeLog();
        })
      })
    },
  }
}